module.exports = __webpack_public_path__ + "img/google-play.ecc7cbd3.png";